import { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { Typography } from '@mui/material';
import { Box } from '@mui/material';
import { List, ListItem, ListItemText, ListItemAvatar, Avatar } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import EmailIcon from '@mui/icons-material/Email';
// import GroupIcon from '@mui/icons-material/Group';
import CodeIcon from '@mui/icons-material/Code';
import { MahiContext, mahiTokenFromMahiContext } from '../../state/MahiContext';
import { useContext } from 'react';
// import { useRolesFromMahiToken } from '../../../hooks/useRolesFromMahiToken';
import { format } from 'date-fns';

// import { hikoAlert } from '../../../utils/HikoAlert';

export default function UserProfile() {
    console.log('UserProfile function started')
    // const profileClaims = await getAccessTokenClaims();
    const [profileClaims, setProfileClaims] = useState(undefined);
    const { accounts } = useMsal();
    // let userRoles = useRolesFromMahiToken();

    const mahiContext = useContext(MahiContext)
    // console.log('UserProfile mahiContext', mahiContext)
    const userRoles = mahiContext.userRoles

    const mahiTokenObject = mahiTokenFromMahiContext(mahiContext)

    useEffect(() => { // There's a hook for this - useRolesFromProfile()

        const getProfileClaims = () => {
            let theProfileClaims = {};
            if (accounts && accounts[0]) {
                theProfileClaims = accounts[0].idTokenClaims;
            }
            setProfileClaims(theProfileClaims);
        };
        getProfileClaims();

        // setProfileClaims(userRoles);

    }, [userRoles, accounts]);

    return (
        <Box className="Page UserProfile">
            <Typography variant="h3">My Profile</Typography>

            {
                profileClaims
                    ?
                    <>
                        <List>
                            <ListItem key="name">
                                <ListItemAvatar>
                                    <Avatar>
                                        <PersonIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    primary={mahiTokenObject.name}
                                    secondary="name"
                                />
                            </ListItem>
                            <ListItem key="email">
                                <ListItemAvatar>
                                    <Avatar>
                                        <EmailIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    primary={mahiTokenObject.email}
                                    secondary="email"
                                />
                            </ListItem>
                            {/* <ListItem key="groups">
                                <ListItemAvatar>
                                    <Avatar>
                                        <GroupIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    primary={profileClaims.groups && profileClaims.groups.join(', ')}
                                    secondary="azure ad groups"
                                />
                            </ListItem> */}
                            <ListItem key="roles">
                                <ListItemAvatar>
                                    <Avatar>
                                        <AccountBoxIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    primary={userRoles && userRoles.join(', ')}
                                    secondary="mahi roles"
                                />
                            </ListItem>
                            <ListItem key="ad-token">
                                <ListItemAvatar>
                                    <Avatar>
                                        <CodeIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    primary={
                                        <>
                                            <dl style={{marginBottom: 0}}>
                                                <dt><em>Issued:</em></dt><dd>{format(profileClaims.iat * 1000, "iiii d MMMM, h:mmaaa")}</dd>
                                                <dt><em>Expires:</em></dt><dd>{format(profileClaims.exp * 1000, "iiii d MMMM, h:mmaaa")}</dd>
                                            </dl>
                                        </>
                                    }
                                    secondary="Azure AD Token"
                                />
                            </ListItem>
                            <ListItem key="mahi-token">
                                <ListItemAvatar>
                                    <Avatar>
                                        <CodeIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    primary={
                                        <>
                                            <dl style={{marginBottom: 0}}>
                                                <dt><em>Issued:</em></dt><dd>{format(mahiTokenObject.iat * 1000, "iiii d MMMM, h:mmaaa")}</dd>
                                                <dt><em>Expires:</em></dt><dd>{format(mahiTokenObject.exp * 1000, "iiii d MMMM, h:mmaaa")}</dd>
                                                <dt><em>Issuer / Audience:</em></dt><dd>{mahiTokenObject.iss} / {mahiTokenObject.aud}</dd>
                                            </dl>
                                        </>
                                    }
                                    secondary="Mahi Token"
                                />
                            </ListItem>
                        </List>
                        {/* <Button onClick={handleButtonClick}>Get a Toast</Button>  */}
                    </>

                    :
                    <p>Log in to see your profile</p>
            }
        </Box>

    );
}


